export const CARNET_DES_MONDES = {
  path: "/le-carnet-des-mondes",
  title: "Le Carnet des Mondes",
  issue: "N°1",
  date: "Novembre 2026",
  subtitle: "Entrer dans la saison sombre",
  flipbookUrl: "https://heyzine.com/flip-book/482d4f5574.html",
  coverUrl: "https://cdnm.heyzine.com/files/uploaded/482d4f55740899a0b491ba6fd5f3c526f35ea55b.pdf-thumb.jpg",
  seoTitle: "Le Carnet des Mondes — N°1 Novembre 2026 | Entre Les Mondes",
  seoDescription: "Découvrez le premier Carnet des Mondes : traditions vivantes, tambours, mégalithes, réflexions et voyages en Irlande. Un magazine numérique à feuilleter.",
};

export const CARNET_RUBRIQUES = [
  { number: "01", title: "Traditions & passages de saison", text: "Samhain, les traditions anciennes et leur place dans notre monde actuel." },
  { number: "02", title: "Tambours & transmission", text: "La création artisanale, la matière, le rythme et la Toile du Wyrd." },
  { number: "03", title: "Pierres & lieux anciens", text: "Les paysages, les mégalithes et notre manière de les découvrir." },
  { number: "04", title: "Réflexions & cheminement", text: "Le regard porté sur la spiritualité, l’ego et les questions qui nourrissent nos expériences." },
  { number: "05", title: "SwissEire — Aux origines", text: "Découvrir l’Irlande autrement, à travers ses paysages, son histoire et ses traditions." },
];

export const CARNET_QUOTE = "Nous ne pouvons pas retourner dans le passé. Mais nous pouvons renouer avec ce qu'il nous a transmis, redonner une place aux traditions et les faire vivre dans le monde d'aujourd'hui.";